<script setup lang="ts">
interface Props {
  icon: string;
  circle?: boolean;
  primary?: boolean;
  size?: string;
  buttonSize?: boolean;
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
});

defineEmits<{
  click: [];
}>();
</script>

<template>
  <button
    class="svg-button uk-button uk-border-rounded uk-flex uk-flex-middle uk-flex-center uk-padding-small"
    :class="{
      [`uk-border-${circle ? 'circle' : 'rounded'}`]: true,
      [`uk-button-${primary ? 'primary' : 'default'}`]: true,
      'svg-button-custom-style': buttonSize,
    }"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <img
      class="svg-button-custom"
      :style="{
        height: size ? size : '1rem',
      }"
      :src="`./icons/${icon}.svg`"
    />
    <slot></slot>
  </button>
</template>
